module.exports = "<div class=\"qrCode_content\">\r\n    <div id=\"qrCode\"></div>\r\n</div>\r\n<!-- <div id=\"gesturepwd\"></div> -->";


//////////////////
// WEBPACK FOOTER
// ./src/component/qrCode/qrCode.html
// module id = 201
// module chunks = 0